import { render, staticRenderFns } from "./Waste.vue?vue&type=template&id=e48a2a20&scoped=true&"
import script from "./Waste.vue?vue&type=script&lang=js&"
export * from "./Waste.vue?vue&type=script&lang=js&"
import style0 from "./Waste.vue?vue&type=style&index=0&id=e48a2a20&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e48a2a20",
  null
  
)

export default component.exports